<template>
  <div class="course-item-box">
<!--    <img-->
<!--      alt-->
<!--      class="course-item-icon"-->
<!--      src="@/assets/img/h5/courseDetail/videoPlayIcon.png"-->
<!--    />-->
    <img
        alt
        class="course-item-img"
        :src="detailData.goodsThumb"
    />

    <div class="course-item-info van-hairline--bottom">
      <div class="info-left">
        <div class="info-left-top van-ellipsis">{{ detailData.goodsName }}</div>
        <!-- <div class="info-left-bottom">{{detailData.duration}}</div> -->
        <div
          class="info-left-bottom"
          v-text="'总时长：' + getDuration(detailData.catLength)"
        ></div>
        <div class="info-right">
          <div
              class="info-right-bottom"
              v-if="
            !isRecommend &&
            detailData.courseGoodsLearnLogEntity &&
            detailData.courseGoodsLearnLogEntity.playTime < detailData.catLength
          "
              v-text="
            '已学' + getDuration(detailData.courseGoodsLearnLogEntity.playTime)
          "
          ></div>
          <div v-else></div>
          <div
              class="info-right-top info-right-top_opcity"
              v-if="
            !isRecommend &&
            !(goodsId === detailData.goodsId) &&
            detailData.courseGoodsLearnLogEntity != null &&
            detailData.courseGoodsLearnLogEntity.playTime < detailData.catLength
          "
          >
            {{ '继续学习' }}<van-icon name="arrow" color="#1779FF"/>
          </div>
          <div
              class="info-right-top"
              v-if="
            !isRecommend &&
            !(goodsId === detailData.goodsId) &&
            detailData.courseGoodsLearnLogEntity == null
          "
          >
            {{ '现在学习' }}<van-icon name="arrow" color="#fff"/>
          </div>
          <div
              class="info-right-top"
              v-if="
            !isRecommend &&
            !(goodsId === detailData.goodsId) &&
            detailData.courseGoodsLearnLogEntity != null &&
            detailData.courseGoodsLearnLogEntity.playTime >=
              detailData.catLength
          "
          >
            {{ '已学完' }}
          </div>
          <div
              class="info-right-top"
              v-if="isRecommend && !detailData.channelFree"
          >
            {{ '开通课程' }}
          </div>
          <div
              class="info-right-top"
              v-if="isRecommend && detailData.channelFree"
              style="color: #4da7f9; background-color: #daedf9"
          >
            <van-icon name="play-circle-o" color="#fff"/> {{ '免费试看' }}
          </div>
          <div
              class="info-right-top"
              v-if="!isRecommend && goodsId === detailData.goodsId && isPlay === 0"
              style="color: #4da7f9; background-color: #daedf9"
          >
            <van-icon name="bar-chart-o" color="#4da7f9"/> {{ '播放中' }}
          </div>
          <div
              class="info-right-top"
              v-if="!isRecommend && goodsId === detailData.goodsId && isPlay === 1"
          >
            <van-icon name="play-circle-o" color="#fff"/> {{ '暂停播放' }}
          </div>
          <div
              class="info-right-top"
              v-if="!isRecommend && goodsId === detailData.goodsId && isPlay === 3"
          >
            {{ '已结束' }}
          </div>
          <div
              class="info-right-top"
              v-if="!isRecommend && goodsId === detailData.goodsId && isPlay === 4"
          >
            <van-icon name="play-circle-o" color="#fff"/> {{ '待播放' }}
          </div>
        </div>
      </div>

    </div>
  </div>
</template>
<script>
import * as dateUtil from '@/api/dateUtil'
export default {
  name: "CourseVideoLink",
  props: ['detailData', 'isRecommend', 'isPlay', 'goodsId'],
  data () {
    return {
    };
  },
  components: {

  },
  mounted () {

  },
  methods: {

    getDuration (val) {
      if (val) {
        return dateUtil.getDuration(val)
      }
    }
  },
}
</script>
<style lang="less" scoped>
::v-deep .van-hairline--bottom::after {
  display: none;
}
.course-item-icon {
  margin: 15px 0;
  width: 14px;
  height: 14px;
}
.course-item-img {
  width: 123px;
  height: 92px;
  border-radius: 6px;
  object-fit: cover;
}
.course-item-box {
  display: flex;
  justify-content: space-between;
  margin-top: 18px;
  &:first-child {
    margin-top: 6px;
  }
  .course-item-info {
    margin-left: 10px;
    display: flex;
    justify-content: space-between;
    width: 100%;
    padding: 5px 0;
    .info-left {
      .info-left-top {
        width: 200px;
        height: 14px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
        line-height: 14px;
      }
      .info-left-bottom {
        .info-right > .info-right-bottom;
        margin-top: 12px;
      }
    }
    .info-right {
      margin-top: 7px;
      text-align: right;
      display: flex;
      justify-content: space-between;
      .info-right-top {
        display: inline-block;
        text-align: center;
        background: #207AFB;
        border-radius: 16px;
        width: 80px;
        font-size: 7px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #fff;
        line-height: 1.5;
        padding: 5px 0;
        &.learned {
          background: rgba(247, 216, 216, 1);
          color: #fa313d;
        }
      }
      .info-right-top_opcity {
        color: #1779FF;
        background: rgba(23, 121, 255, 0.1);
      }
      .info-right-bottom {
        height: 12px;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(161, 161, 161, 1);
        line-height: 12px;
      }
      .info-right-bottom {
        margin-top: 6px;
      }
    }
  }
}
</style>
